import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const NotFound = () => {
  return (
    <div className="min-h-[70vh] flex items-center justify-center py-20" data-testid="not-found-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center px-6"
      >
        <div className="font-serif text-9xl font-light text-sage-200 mb-6">
          404
        </div>
        <h1 className="font-serif text-4xl font-light text-charcoal mb-4">
          Page Not Found
        </h1>
        <p className="text-charcoal/60 text-lg mb-10 max-w-md mx-auto">
          Sorry, the page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            asChild
            size="lg"
            className="bg-charcoal hover:bg-charcoal/90 text-white rounded-full px-8 gap-2"
          >
            <Link to="/">
              <Home className="w-5 h-5" />
              Go Home
            </Link>
          </Button>
          <Button
            asChild
            variant="outline"
            size="lg"
            className="rounded-full px-8 border-charcoal text-charcoal hover:bg-charcoal hover:text-white gap-2"
            onClick={() => window.history.back()}
          >
            <button type="button">
              <ArrowLeft className="w-5 h-5" />
              Go Back
            </button>
          </Button>
        </div>
      </motion.div>
    </div>
  );
};

export default NotFound;
